import { useRightPaneExpandContext } from "@/context/RightPaneExpandContext";
import { useEffect, useState } from "react";
import { useCanvasUi } from "../context/CanvasUiContext";

/**
 * Width in CSS pixels of the React Flow wrapper (`reactFlowWrapperEl` in
 * `CanvasUiContext`, set by `CanvasPageInner` ref callback). Updates on resize
 * and when the right pane width changes (layout reflow).
 */
export function useCanvasWidth(): number {
  const { reactFlowWrapperEl } = useCanvasUi();
  const { rightPanelWidth } = useRightPaneExpandContext();
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = reactFlowWrapperEl;
    if (!el) return;
    const updateWidth = () => setWidth(el.clientWidth);
    const ro = new ResizeObserver(updateWidth);
    ro.observe(el);
    updateWidth();
    const rafId = requestAnimationFrame(() => {
      updateWidth();
    });
    return () => {
      cancelAnimationFrame(rafId);
      ro.disconnect();
    };
  }, [reactFlowWrapperEl]);

  useEffect(() => {
    const el = reactFlowWrapperEl;
    if (!el) return;
    const rafId = requestAnimationFrame(() => {
      setWidth(el.clientWidth);
    });
    return () => cancelAnimationFrame(rafId);
  }, [reactFlowWrapperEl, rightPanelWidth]);

  return width;
}
